// Master service catalogue. Slugs are stable, used for testIds + i18n keys.
export const SERVICE_SLUGS = [
  'condition-prepurchase',
  'damage',
  'draft-bunker',
  'on-off-hire',
  'ism-isps-mlc',
  'pre-vetting-sire-cdi',
  'psc-inspection',
  'remote-vdr',
  'navigation-audit',
  'blending-services',
  'loss-control-expediting',
];

// Slug used in the Contact "service of interest" dropdown for non-service enquiries.
export const GENERAL_INQUIRIES_SLUG = 'general-inquiries';

// Map a slug to a Lucide icon name (for dynamic rendering on the front-end)
export const SERVICE_ICONS = {
  'condition-prepurchase': 'ClipboardCheck',
  'damage': 'ShieldAlert',
  'draft-bunker': 'Fuel',
  'on-off-hire': 'Anchor',
  'ism-isps-mlc': 'FileCheck2',
  'pre-vetting-sire-cdi': 'Search',
  'psc-inspection': 'Shield',
  'remote-vdr': 'Radio',
  'navigation-audit': 'Compass',
  'blending-services': 'Beaker',
  'loss-control-expediting': 'Timer',
};
